import { useTranslate } from "@/utils/lang";
import { RadioGroup, Flex, Radio, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { Draft_Words } from "../lang";
import { draftStore } from "../store";

function ResolutionRadio() {
  const { translate } = useTranslate();
  return (
    <Flex fontSize="14px" mt="16px">
      <Text mr="1em">{translate(Draft_Words.resolution)}</Text>
      <RadioGroup
        color="text.secondary"
        w="70%"
        value={String(draftStore.resolution)}
        onChange={(v) => draftStore.setResolution(Number(v))}
      >
        <Flex justify="space-between" flexGrow={1}>
          <Radio colorScheme="brand" bg="white" value="512">
            <Text fontSize="14px">{translate(Draft_Words["resolution-normal"])}</Text>
          </Radio>
          <Radio colorScheme="brand" bg="white" value="768">
            <Text fontSize="14px">{translate(Draft_Words["resolution-hq"])}</Text>
          </Radio>
          <Radio
            colorScheme="brand"
            bg="white"
            _disabled={{ bg: "text.disabled" }}
            value="1024"
            isDisabled={draftStore.size !== "1:1"}
          >
            <Text fontSize="14px">{translate(Draft_Words["resolution-hd"])}</Text>
          </Radio>
        </Flex>
      </RadioGroup>
    </Flex>
  );
}

export default observer(ResolutionRadio);
